document.addEventListener('DOMContentLoaded', () => {
    const page = document.querySelector('.myaccount');
    if (!page) return;

    const myCoursesPanel = page.querySelector('[data-tab-panel="my-courses"]');
    if (!myCoursesPanel) return;

    myCoursesPanel.addEventListener('click', (e) => {
        const trigger = e.target.closest('[data-action="goto-tab"]');
        if (!trigger) return;
        const targetTab = trigger.dataset.targetTab;
        if (!targetTab) return;

        e.preventDefault();

        const navLink = page.querySelector(`.myaccount__tabs-link[data-tab="${targetTab}"]`);
        if (!navLink) return;
        navLink.click();
    });
});
